"use strict";

import { dataTemplateConstants } from "../_constants";

export const INITIAL_DATA_TEMPLATE_STATE = {
     dataTemplateTypeList: [],
     dataTemplateAttributeList: [],
     dataTemplateTypeUploadsList: [],
     tableValueDetails: null,
     list: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },
     tableValueList: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },
     dataSchema: {},
     manageDataValues: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },

     dataRowDetails: {},
     details: {},
     labels: [],
     types: [],
     participantUser:[],
     participantUserCreateStatus:null
};

export function dataTemplate(state = INITIAL_DATA_TEMPLATE_STATE, action) {
     switch (action.type) {
          case dataTemplateConstants.DATA_TEMPLATE_LIST_REQUEST:
               return {
                    ...state,
                    list: {
                         data: [],
                    },
               };
          case dataTemplateConstants.DATA_TEMPLATE_LIST_COMPLETE:
               return {
                    ...state,
                    list: {
                         data: [...action.payload.recordsList],
                         totalPageCount: action.payload.totalPageCount,
                         totalRecords: action.payload.totalRecords,
                    },
               };
          case dataTemplateConstants.DATA_TEMPLATE_GET_TEMPLATE_LIST_COMPLETE:
               return {
                    ...state,
                    dataTemplateTypeList: action.payload,
               };

          case dataTemplateConstants.DATA_TEMPLATE_GET_ALL_SCHEME_ATTRIBUTE_COMPLETE:
               return {
                    ...state,
                    dataTemplateAttributeList: action.payload,
               };

          case dataTemplateConstants.DATA_TEMPLATE_GET_ALL_TYPES_COMPLETE:
               return {
                    ...state,
                    dataTemplateTypeUploadsList: action.payload,
               };
          case dataTemplateConstants.DATA_TEMPLATE_SCHEMA_VALUE_GET_COMPLETE:
               return {
                    ...state,
                    tableValueDetails: action.payload,
               };
          case dataTemplateConstants.DATA_TEMPLATE_GET_ALL_SCHEMA_LIST_COMPLETE:
               return {
                    ...state,
                    tableValueList: {
                         data: [...action.payload.recordsList],
                         totalPageCount: action.payload.totalPageCount,
                         totalRecords: action.payload.totalRecords,
                    },
               };

          case dataTemplateConstants.GET_DATA_TEMPLATE_JSON_SCHEMA_COMPLETE:
               return {
                    ...state,
                    dataSchema: {
                         ...action.payload,
                    },
               };

          case dataTemplateConstants.DATA_TEMPLATE_GET_VALUE_COMPLETE:
               return {
                    ...state,
                    manageDataValues: {
                         data: [...action.payload.recordsList],
                         totalPageCount: action.payload.totalPageCount,
                         totalRecords: action.payload.totalRecords,
                    },
               };

          case dataTemplateConstants.DATA_TEMPLATE_GET_SCHEMA_RECORD_COMPLETE:
               return {
                    ...state,
                    dataRowDetails: {
                         ...action.payload.dataObject,
                    },
               };

          case dataTemplateConstants.DATA_TEMPLATE_GET_COMPLETE:
               return {
                    ...state,
                    details: { ...action.payload },
               };

          case dataTemplateConstants.GET_DATA_TEMPLATE_LABELS_COMPLETE:
               return {
                    ...state,
                    labels: [...action.payload],
               };

          case dataTemplateConstants.GET_DATA_TEMPLATE_TYPES_COMPLETE:
               return {
                    ...state,
                    types: [...action.payload],
               };
          case dataTemplateConstants.DATA_TEMPLATE_GET_USER_ACCOUNT_COMPLETE:
               return {
                    ...state,
                    participantUser:[...action.payload]
               }
          case dataTemplateConstants.DATA_TEMPLATE_PARTICIPANT_USER_ACCOUNT_CREATE_COMPLETE:
               return {
                    ...state,
                    participantUserCreateStatus:[...action.payload]
               }        
     }

     return state;
}
